import { useGetEventQuery, useGetPublicEventQuery, useLazyGetEventQuery } from '@event/services/events';
import { EventTypes, PublicOnSiteEvent, PublicWebinarEvent } from '@event/types/event';

const useEvent = (eventType: EventTypes, eventId: number) => {
    const {
        data: event,
        isLoading,
        isFetching,
        error: eventError,
    } = useGetEventQuery({ type: eventType, id: Number(eventId) });

    const [getEvent, { isLoading: isLazyEventLoading, isFetching: isLazyEventFetching, error: lazyEventError }] =
        useLazyGetEventQuery();

    return {
        event,
        isEventLoading: isLoading,
        isEventFetching: isFetching,
        eventError,
        lazy: {
            getEvent,
            loading: isLazyEventLoading,
            fetching: isLazyEventFetching,
            error: lazyEventError,
        },
    };
};

type UsePublicEventParams = {
    eventType: EventTypes;
    eventId: number;
    colleagueHash?: string | null;
    guestAccessHash?: string | null;
    params?: Parameters<typeof useGetPublicEventQuery>[1];
};

const usePublicEvent = ({
    eventType,
    eventId,
    colleagueHash,
    guestAccessHash,
    params,
}: UsePublicEventParams): {
    event: PublicOnSiteEvent | PublicWebinarEvent;
    isEventLoading: boolean;
    isEventFetching: boolean;
    eventError: ReturnType<typeof useGetPublicEventQuery>['error'];
} => {
    const {
        data: event,
        isLoading,
        error: eventError,
        isFetching,
    } = useGetPublicEventQuery({ type: eventType, id: Number(eventId), colleagueHash, guestAccessHash }, params);

    return { event, isEventLoading: isLoading, isEventFetching: isFetching, eventError };
};

export { useEvent, usePublicEvent };
